<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fZXPJL/tc-custom/9783989735392.jpg?1736355145041" alt="This image is the cover for the book Chain Reaction and Three More Stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chain Reaction and Three More Stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>"Chain Reaction and Three More Stories" by Boyd Ellanby is an enthralling anthology that takes readers on a journey through the realms of science fiction and human intrigue. In "Chain Reaction," three university colleagues face a former friend, Rothman, in a tense poker game at a sanitarium, where the specter of a world-ending experiment looms. This story explores the thin line between genius and madness, as Rothman's dire predictions challenge the limits of scientific ambition and trust. Next, "What Do You Read?" transports us to a future where machines dominate the literary world, leaving seasoned writer Herbert Carre to grapple with the existential threat of Script-Lab's machine-generated narratives. This story raises questions about creativity, technology, and the essence of human storytelling. In "Category Phoenix," Dr. David Wong's discovery of eternal youth becomes a deadly secret in a dystopian society ruled by Leader Marley. As Wong navigates this oppressive world, the story examines the ethical implications of immortality and the power struggles it ignites. Finally, "Show Business" offers a whimsical escape to Luna City, where a Venusian named Dworken spins tales of Martian entertainment in a nearly deserted bar. This lighthearted tale blends humor with science fiction, inviting readers to question the limits of gullibility and the pursuit of spectacle. Together, these stories delve into the complexities of technology, power, and human nature, making "Chain Reaction and Three More Stories" a must-read for fans of thought-provoking science fiction and captivating narratives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Boyd Ellanby
      </h2>
      
      <p class="authorDescription body article">Boyd Ellanby was a pseudonym used by a mid-20th-century science fiction writer known for creating compelling narratives that explored themes of human nature, power dynamics, and futuristic societies. Through a series of thought-provoking stories, Ellanby captivated readers with imaginative settings and philosophical depth, using speculative fiction as a lens to examine societal evolution and moral dilemmas. Despite the anonymity surrounding the author's true identity, Ellanby's work continues to resonate with fans of classic science fiction, standing as a testament to the genre's ability to inspire both wonder and reflection.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11d31bac